/**
 * Company: SPHMedia
 * Description: SectionTag is to display the 5 sections in different styles, used for article cards
 */

import { Section, SectionDisplayTagMap } from "@src/app/types/Data";
import clsx from "clsx";
import type { ReactElement } from "react";

const colorClsMap = {
  [Section.PERSPECTIVE]: "bg-tag-green",
  [Section.GOOD_READS]: "bg-tag-peach",
  [Section.OVERVIEW]: "bg-tag-yellow",
  [Section.VIDEOS]: "bg-tag-blue",
};

export { BlockTag, SliceTag };

function BlockTag({
  section,
  className,
  testId = "",
}: {
  section: Exclude<Section, "home">;
  className?: string;
  testId?: number | string;
}): ReactElement {
  const text = SectionDisplayTagMap[section];

  return (
    <button
      className={clsx("w-[60px]", className)}
      onClickCapture={(e) => {
        toSectionPage(e, section);
      }}
      onTouchStartCapture={(e) => {
        toSectionPage(e, section);
      }}
      onTouchEndCapture={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        data-testid={`block-tag-${testId}`}
        className={clsx(
          "flex h-[28px] w-full items-center whitespace-nowrap px-[16px] text-label text-primary",
          colorClsMap[section],
        )}
      >
        {text}
      </div>
    </button>
  );
}

function SliceTag({
  section,
  className,
  testId = "",
}: {
  section: Exclude<Section, "home">;
  className?: string;
  testId?: number | string;
}): ReactElement {
  const text = SectionDisplayTagMap[section];

  return (
    <button
      className="w-[37px]"
      onClickCapture={(e) => {
        toSectionPage(e, section);
      }}
      onTouchStartCapture={(e) => {
        toSectionPage(e, section);
      }}
      onTouchEndCapture={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <span
        data-testid={`slice-tag-${testId}`}
        className={clsx("flex h-[20px] w-[37px] items-center", className)}
      >
        <span
          className={clsx(
            "inline-block h-[16px] w-[3px]",
            colorClsMap[section],
          )}
        />
        <span className="whitespace-nowrap pl-[6px] text-label text-tertiary">
          {text}
        </span>
      </span>
    </button>
  );
}

function toSectionPage(
  e: React.MouseEvent | React.TouchEvent,
  section: Section,
) {
  e.stopPropagation();
  e.preventDefault();

  requestAnimationFrame(() => {
    window.location.href = `/${section}`;
  });
}
